import { SetSortOptionsEnum } from "modules/cards/model/set";
import type { SortOption as MainbarSortOption } from "modules/common/components/mainbar/types";
import type { SortOption as MobileSortOption } from "modules/common/components/mainbar/MobileSortControls";

/**
 * Shared sort options for sets - used by both desktop and mobile mainbars
 */
export const SET_SORT_OPTIONS: MainbarSortOption<SetSortOptionsEnum>[] = [
  {
    key: "name",
    name: "Name",
    enum: SetSortOptionsEnum.Name,
  },
  {
    key: "code",
    name: "Code",
    enum: SetSortOptionsEnum.Code,
  },
  {
    key: "releaseDate",
    name: "Release Date",
    enum: SetSortOptionsEnum.ReleaseDate,
  },
  {
    key: "totalCards",
    name: "Total Cards",
    enum: SetSortOptionsEnum.TotalSetSize,
  },
  {
    key: "marketCap",
    name: "Market Cap",
    enum: SetSortOptionsEnum.MarketCap,
  },
];

/**
 * Mobile-compatible version using the MobileSortControls SortOption interface
 */
export const SET_SORT_OPTIONS_MOBILE: MobileSortOption<SetSortOptionsEnum>[] =
  SET_SORT_OPTIONS.map((option) => ({
    key: option.key,
    name: option.name,
    enum: option.enum,
  }));
